import React from 'react';
import { cn } from '../../lib/utils';
import { UserProfile } from '../../types';

interface Tab {
  id: string;
  label: string;
  icon: any;
  badge?: number;
}

interface MobileBottomNavProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (id: string) => void;
  user: UserProfile;
}

export const MobileBottomNav = ({ tabs, activeTab, onChange, user }: MobileBottomNavProps) => (
  <div className="md:hidden fixed bottom-6 left-6 right-6 bg-slate-900 rounded-[2.5rem] px-8 py-4 flex items-center justify-between shadow-2xl z-[100]">
    {tabs.map((tab: any) => (
      <button
        key={tab.id}
        onClick={() => onChange(tab.id)}
        className={cn(
          "flex flex-col items-center gap-1 transition-all duration-300 relative",
          activeTab === tab.id ? "text-emerald-500 scale-110" : "text-slate-500"
        )}
      >
        <tab.icon className="w-6 h-6" />
        <span className="text-[8px] font-black uppercase tracking-widest">{tab.label}</span>
        {tab.badge && tab.badge > 0 ? (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[7px] font-black rounded-full flex items-center justify-center border-2 border-slate-900 animate-pulse">
            {tab.badge}
          </span>
        ) : null}
      </button>
    ))}
    <button
      className="flex flex-col items-center gap-1 text-slate-500"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <img src={user.avatar} className="w-6 h-6 rounded-full border border-white/20" alt="" />
      <span className="text-[8px] font-black uppercase tracking-widest">Profil</span>
    </button>
  </div>
);
